import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import FormGroup from "reactstrap/lib/FormGroup";
import Input from "reactstrap/lib/Input";
import Label from "reactstrap/lib/Label";
import QuestionType from "./QuestionType";

class QuestionYesNo extends QuestionType {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    getValue() {
        let v = super.getValue();
        if (v) {
            if (Array.isArray(v) && v.length > 0) {
                v = v[0];
            }
        }
        if (typeof v === "undefined" || v == null) {
            if (this.hasVorauswahl()) {
                v = this.getVorauswahl();
                this.setValue(v);
            }
        }
        return v;
    }



    onChangeOption(e, val) {
        this.setValue(val);
        return e;
    }

    isChecked(val) {
        return this.getValue() === val;
    }

    /** Markiert die gewaehlte bzw. gesperrte Option fuer die Kartenoptik. */
    optionClass(val) {
        const disabled = this.isFinished() || this.isDisabled();
        return (this.isChecked(val) ? "is-selected" : "") + (disabled ? " is-disabled" : "");
    }

    render() {
        return <Container>
            <Row>
                <Col md={12}>
                    <FormGroup className={"p-1 yesno-container "+(this.hasError() ? "error" : "")}>
                        {/* Beide Optionen liegen nebeneinander wie ein Segment-Schalter */}
                        <div className={"yesno-options"}>
                            <div className={"option"}>
                                <Label check className={this.optionClass(true)}>
                                    <Input disabled={this.isFinished() || this.isDisabled()}
                                           type={"radio"}
                                           checked={this.isChecked(true)}
                                           onChange={(e) => this.onChangeOption(e, true)} name={"yesno"+this.getId()} />
                                    Ja
                                </Label>
                            </div>
                            <div className={"option"}>
                                <Label check className={this.optionClass(false)}>
                                    <Input disabled={this.isFinished() || this.isDisabled()}
                                           type={"radio"} checked={this.isChecked(false)}
                                           onChange={(e) => this.onChangeOption(e, false)} name={"yesno"+this.getId()} />
                                    Nein
                                </Label>
                            </div>
                        </div>
                        <Row>
                            {this.renderErrors()}
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
        </Container>;
    }
};

QuestionYesNo.propTypes = {

};


export default QuestionYesNo;
